import { tv, type VariantProps } from '@workspace/lib';

export const imageGalleryVariants = tv({
  slots: {
    container: 'px-md py-xl md:px-full-banner md:py-3xl',
    header: 'gap-md',
    heading: 'text-secondary-400',
    link: 'mt-xs gap-1 font-heading text-base/5 font-bold text-primary focus-visible:outline-primary md:mt-sm md:text-lg/6',
    grid: 'gap-xs md:auto-rows-129.5 md:gap-sm',
    imageWrapper: 'h-53 bg-secondary-50 focus-visible:outline-primary md:h-129.5',
    modalContent: 'pt-xl md:pb-xl',
    modalContainer: 'max-w-300',
    modalImage: 'h-43.75 w-77.5 rounded-2xl after:bg-black/20 md:h-168.75 md:w-300 md:aspect-video',
    modalLink:
      'mt-lg text-center font-heading text-lg/6 font-normal text-white underline [leading-trim:both] [text-edge:cap] [text-decoration-style:solid] [text-decoration-skip-ink:auto] [text-decoration-thickness:auto] [text-underline-offset:auto] [text-underline-position:from-font]',
    modalNavigationButton: 'h-6 w-6 bg-transparent text-white hover:text-white md:h-10 md:w-10',
    modalDesktopNavigation: 'w-324',
  },
  variants: {
    hasTabs: {
      true: {
        grid: 'mt-lg md:mt-xl',
      },
      false: {
        grid: 'mt-xl md:mt-2xl',
      },
    },
  },
  defaultVariants: {
    hasTabs: true,
  },
});

export type ImageGalleryVariants = VariantProps<typeof imageGalleryVariants>;
